import { useState } from 'react';

import { AccountMenu } from './AccountMenu';
import { Icon } from '../Icon';
import loginAvatarSrc from '../../../assets/teacher-avatars/teacher-2.png';
import styles from './ProductNavigation.module.css';
import { productModules } from './navigation-data';

export function ProductNavigation({ defaultActive }: { defaultActive?: string }) {
  const [active, setActive] = useState<string | null>(defaultActive ?? null);
  const [openMenu, setOpenMenu] = useState<string | null>(null);

  return <nav aria-label="产品模块导航" className={styles.nav}>
    <a className={styles.homeLink} href="#/">
      <img alt="校管家" className={styles.logo} src="./brand/xiaogj-nav-logo.png" />
    </a>
    <div className={styles.items}>
      {productModules.map((item, index) => {
        const menuId = `product-navigation-menu-${index}`;
        const isOpen = openMenu === item.label;

        return <div className={styles.menuTrigger} key={item.label} onBlur={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget)) setOpenMenu(null);
        }} onMouseEnter={() => setOpenMenu(item.label)} onMouseLeave={() => setOpenMenu(null)}>
          <button aria-controls={menuId} aria-expanded={isOpen} aria-pressed={active === item.label} className={active === item.label ? styles.active : styles.item} onClick={() => setActive(item.label)} onFocus={() => setOpenMenu(item.label)} onKeyDown={(event) => {
            if (event.key === 'Escape') setOpenMenu(null);
          }} type="button">
            <Icon name={item.icon} size="lg" />
            <span>{item.label}</span>
          </button>
          {isOpen && <div aria-label={`${item.label}菜单`} className={styles.navigationMenu} id={menuId} role="menu">
            {item.groups.map((group, groupIndex) => (
              <div key={`${item.id}-${groupIndex}`}>
                {group.map((entry) => <a className={styles.menuItem} href={entry.href} key={entry.label} role="menuitem">{entry.label}</a>)}
                {groupIndex < item.groups.length - 1 ? <div aria-hidden="true" className={styles.menuDivider} /> : null}
              </div>
            ))}
          </div>}
        </div>;
      })}
    </div>
    <div className={styles.right}>
      <button className={styles.campus} type="button">
        岳麓校区
        <Icon className={styles.campusIcon} name="a-arrow-down" size="sm" />
      </button>
      <AccountMenu avatarSrc={loginAvatarSrc} onOpenChange={(open) => { if (open) setOpenMenu(null); }} />
    </div>
  </nav>;
}
